// extracted by mini-css-extract-plugin
export var label = "_g-2";
export var logo = "_g-1";
export var topNav = "_g-0";